// Conversions already reported to the shell's AppsFlyer, as in rips-ui. sessionStorage, so a refresh on the success screen still counts.
const SENT_CONVERSIONS_KEY = 'cc.analytics.shellConversions.v1';

let memorySent = new Set<string>();

function sessionStore(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

function readSentConversions(): Set<string> {
  const store = sessionStore();
  if (store === null) return memorySent;
  try {
    const stored = JSON.parse(store.getItem(SENT_CONVERSIONS_KEY) ?? '[]') as unknown;
    const keys = Array.isArray(stored) ? stored.filter((key): key is string => typeof key === 'string') : [];
    // Merged with memory, so keys whose write failed still dedupe.
    return new Set([...memorySent, ...keys]);
  } catch {
    return memorySent;
  }
}

/** Whether `key` was already reported. Records nothing; see {@link markSent}. */
export function hasSent(key: string): boolean {
  return readSentConversions().has(key);
}

/** Records `key` as reported. Idempotent. */
export function markSent(key: string): void {
  const sent = readSentConversions();
  sent.add(key);
  memorySent = sent;
  const store = sessionStore();
  if (store === null) return;
  try {
    store.setItem(SENT_CONVERSIONS_KEY, JSON.stringify([...sent]));
  } catch {
    // Quota or a read-only store: the in-memory copy still dedupes this tab.
  }
}

/** Test seam: forget every reported key. */
export function resetConversionDedupe(): void {
  memorySent = new Set();
  try {
    window.sessionStorage.removeItem(SENT_CONVERSIONS_KEY);
  } catch {
    // No sessionStorage here.
  }
}
